<template>
  <div class="hidden lg:block border-b border-gray-300 leading-none pb-px mb-2">
    <div class="flex flex-wrap overflow-hidden text-xs text-gray-600 uppercase">
      <div class="flex-initial w-36 mr-2">&nbsp;</div>
      <div class="flex-1 flex justify-between w-auto">
        <div>Description</div>
        <div class="mr-1">UoM</div>
      </div>
      <div class="flex-initial flex items-stretch text-center w-72 mx-2">
        <div class="flex-0 w-16 pl-1">Qty</div>
        <div class="flex-1 pl-1">Rate</div>
        <div class="flex-1 pl-1">Row Total</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RowsHeader'
};
</script>